<div id="ebb-stepper-scroller-top"></div>
@if (loading) {
  <mat-progress-bar mode="indeterminate" ></mat-progress-bar>
}
<div [class]="loading ? 'row loading': 'row not-loading'">
  <div class="col-md-12">
    @if (programCycle) {
      <mat-horizontal-stepper linear ebbStepperScroller>
        <mat-step [stepControl]="applicationInput">
          <ng-template matStepLabel >Qualify this property</ng-template>
          <div id="qualify-panel" role="tabpanel"  [hidden]="stepSection !== 1">
            <ebb-start
              [program]="programCycle"
              [dwelling$]="dwelling$"
              [policies]="policies"
              [dwellingNextInProcessComplete]="dwellingNextInProcessComplete"
              (isFormInvalid)="isDwellingFormInvalidChange($event)"
              (nextSection)="changeStepSection($event)"
              (emitDwelling)="handleDwelling($event)">
            </ebb-start>
          </div>
          @if (stepSection === 2) {
            <div id="house-panel" role="tabpanel" >
              <ebb-house
                [dwelling$]="dwelling$"
                [questionnaire$]="questionnaire$"
                (isFormInvalid)="isQuestionnaireFormInvalidChange($event)"
                (leaveForm)="changeStepSection($event)"
                (qualify)="submitQualification($event)"
                [drawerOpen]="drawerOpen"
                [drawerContent]="drawerContent">
              </ebb-house>
            </div>
          }
        </mat-step>
        <mat-step>
          <ng-template matStepLabel>Provide your contact details</ng-template>
          <div id="contact-panel" role="tabpanel" >
            <ebb-contact-details
              [program]="programCycle"
              [programData]="programCycles"
              [userPolicy]="userPolicy"
              [contactData]="contactData"
              [dwelling$]="dwelling$"
              (contact)="submitContact($event)">
            </ebb-contact-details>
          </div>
        </mat-step>
        @if (noB2cAccount) {
          <mat-step>
            <ng-template matStepLabel>Activate your account</ng-template>
            <div id="activate-panel" role="tabpanel" >
              @if (contact$) {
                <ebb-activate
                  [contact$]="contact$"
                  [contactData]="contactData"
                  [message]="responseMessage"
                  [tooManyAttempts]="tooManyAttempts"
                  [activateNextInProcessComplete]="activateNextInProcessComplete"
                  (accountInfo)="createAccount($event)"
                  (loading)="loadingEvent($event)">
                </ebb-activate>
              }
            </div>
          </mat-step>
        }
      </mat-horizontal-stepper>
    }
  </div>
</div>
@if (error) {
  <div class="row">
    <div style="color: red;" class="col-md-12">
      {{ error }}<br />
      Please contact Customer Service at (877) 232-4300 or at <a href="mailto:info@crmp.org">info&#64;crmp.org</a>.
    </div>
  </div>
}
